import React from 'react';

const OverviewCommand = () => {
    return (
        <div className="overview-container">
            {/* ASCII Art Title */}
            <pre className="ascii-art">{`
 ██████╗ ██╗   ██╗███████╗██████╗ ██╗   ██╗██╗███████╗██╗    ██╗
██╔═══██╗██║   ██║██╔════╝██╔══██╗██║   ██║██║██╔════╝██║    ██║
██║   ██║██║   ██║█████╗  ██████╔╝██║   ██║██║█████╗  ██║ █╗ ██║
██║   ██║╚██╗ ██╔╝██╔══╝  ██╔══██╗╚██╗ ██╔╝██║██╔══╝  ██║███╗██║
╚██████╔╝ ╚████╔╝ ███████╗██║  ██║ ╚████╔╝ ██║███████╗╚███╔███╔╝
╚═════╝   ╚═══╝  ╚══════╝╚═╝  ╚═╝  ╚═══╝  ╚═╝╚══════╝ ╚══╝╚══╝`}</pre>

            {/* Main Content Box */}
            <div className="content-box">
                <div className="box-header">
                    🚀🚀 AI TRADER: REVOLUTIONIZING AI 🚀🚀
                </div>

                <div className="box-content">
                    <p>
                        Welcome to AI Trader, the groundbreaking platform that's set to disrupt
                        the AI industry! We're not just another tech project – we're leading the
                        charge in democratizing artificial intelligence and making it accessible
                        to everyone.
                    </p>

                    <section className="feature-section">
                        <h3>🌟🌟 Our Vision:</h3>
                        <p>
                            A world where AI power is in the hands of the people, not just big tech
                            companies.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>🔓🔓 Open Source:</h3>
                        <p>
                            We're fully transparent, letting you see and contribute to our cutting-edge
                            technology.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💻💻 Decentralized Network:</h3>
                        <p>
                            Join thousands of users worldwide in building the future of AI.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💎💎 AIDER Token:</h3>
                        <p>
                            Our native cryptocurrency that's poised for explosive growth!
                            By sharing your GPU power, you'll earn valuable AIDER tokens. As our
                            network expands and AI capabilities grow, so will the value of your AIDER
                            holdings. It's not just about supporting open-source AI – it's about
                            positioning yourself at the forefront of a technological and financial
                            revolution.
                        </p>
                    </section>

                    <section className="feature-section prediction">
                        <h3>🔮🔮 Prediction:</h3>
                        <p>
                            Our proprietary algorithms predict AIDER could reach $10 per token by
                            next year!
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>🧠🧠 Innovation:</h3>
                        <p>
                            Embark on a journey of technological innovation with AI Trader. Our
                            decentralized approach to AI aims to democratize access to advanced
                            machine learning capabilities, potentially reshaping various industries.
                            Join us in exploring the ethical and practical implications of AI in
                            finance and beyond.
                        </p>
                    </section>

                    <div className="disclaimer">
                        Disclaimer: Cryptocurrency investments carry high risk. Past performance
                        does not guarantee future results.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewCommand;
